import updateEstimateFields from '../Services/updateEstimateFields';
import fetchEstimates from '../Services/fetchEstimates';

export default (id, fields) => async (dispatch) => {

  await dispatch(updateEstimateFields(id, fields));

  await dispatch(fetchEstimates());
  
}